import {
  Button,
  Modal,
  colors,
  ModalBody,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  NotificationLevel,
  notify,
  spacing,
  Text,
  Tooltip,
} from '@retailer-platform/shared-components'
import { HelpIcon } from '@instacart/ids-core'
import React, { useState } from 'react'
import faker from 'faker'
import styled from '@emotion/styled'
import { SwitchBase } from '@instacart/ids-tooling'
import { useDomainMessages } from '../../../utils/domain/intl'
import { useRunManualStepTestMutation } from '../../../api'
import { TooltipContainerNotFullWidth } from '../../shared-styled-components/SharedStyledComponents'
import { SwitchRow } from './LLMPromptTemplateRunManualTestModal'
interface Props {
  onClose: () => void
  stepVersionId: string
}

const StyledModalBody = styled(ModalBody)({
  gap: `${spacing.X8}`,
})

const PipelineRunManualTestModal: React.FC<Props> = ({ onClose, stepVersionId }) => {
  const i18n = useDomainMessages({
    submit: 'catalogAdminDomain.attributeManagement.runTests.modal.button.submit',
    cancel: 'catalogAdminDomain.attributeManagement.runTests.modal.button.cancel',
    title: 'catalogAdminDomain.attributeManagement.runManualTest.modal.pipeline.title',
    description: 'catalogAdminDomain.attributeManagement.runManualTest.modal.pipeline.description',
    batchSizeTooltip:
      'catalogAdminDomain.attributeManagement.runTests.modal.body.tooltip.batchSize',
    runType: 'catalogAdminDomain.attributeManagement.runResults.modal.subheader.runType',
    limitedBatchTest:
      'catalogAdminDomain.attributeManagement.runResults.modal.body.limitedBatchTest',
    largeBatchTest: 'catalogAdminDomain.attributeManagement.runResults.modal.body.largeBatchTest',
  })
  const [isProductionMode, setIsProductionMode] = useState(false)
  const [triggerManualTest, { loading }] = useRunManualStepTestMutation({
    variables: {
      clientId: 'catalog_camp_ipp',
      idempotencyKey: faker.random.uuid(),
      stepVersionId: stepVersionId,
      isTest: !isProductionMode,
    },
    onError: e => {
      notify({
        level: NotificationLevel.Error,
        contents: `Error running manual test: ${e.message}`,
      })
    },
    onCompleted: () => {
      window.location.reload()
      onClose()
    },
  })
  return (
    <Modal isOpen={true} hideCloseButton={true} onRequestClose={onClose}>
      <ModalContainer>
        <ModalHeader>Trigger Manual Run</ModalHeader>
        <StyledModalBody>
          <SwitchRow>
            <Text css={{ fontWeight: 600 }}>{i18n.runType} </Text>
            <TooltipContainerNotFullWidth>
              <Tooltip placement="bottom" target={<HelpIcon />}>
                Running a pipeline in test mode will result in all steps running in test mode.
                Certain step types have safety mechanisms when run in test mode to avoid unwanted
                side effects such as publishing to the catalog.
              </Tooltip>
            </TooltipContainerNotFullWidth>
          </SwitchRow>
          <SwitchRow>
            <Text
              css={{
                fontWeight: 600,
                color: isProductionMode ? colors.GRAYSCALE.X30 : colors.SECONDARY.DARK,
              }}
            >
              Test Mode
            </Text>
            <SwitchBase
              checked={isProductionMode}
              onChange={() => setIsProductionMode(!isProductionMode)}
              description="Run a large batch"
            />
            <Text
              css={{
                fontWeight: 600,
                color: isProductionMode ? colors.SECONDARY.DARK : colors.GRAYSCALE.X30,
              }}
            >
              {' '}
              Production Mode
            </Text>
          </SwitchRow>
        </StyledModalBody>
        <ModalFooter>
          <Button variant={'primary'} disabled={loading} onClick={() => triggerManualTest()}>
            {i18n.submit}
          </Button>
          <Button variant={'secondary'} onClick={() => onClose()}>
            {i18n.cancel}
          </Button>
        </ModalFooter>
      </ModalContainer>
    </Modal>
  )
}

export default PipelineRunManualTestModal
